import * as React from 'react';

export default function Clock({...rest}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0025 1.33594C5.79273 1.33594 1.33594 5.7927 1.33594 12.0025C1.33594 18.2121 5.79286 22.669 12.0025 22.669C18.2123 22.669 22.669 18.2123 22.669 12.0025C22.669 5.79256 18.2124 1.33594 12.0025 1.33594ZM12.0025 2.66594C17.4779 2.66594 21.339 6.5271 21.339 12.0025C21.339 17.4777 17.4777 21.339 12.0025 21.339C6.5274 21.339 2.66594 17.4776 2.66594 12.0025C2.66594 6.52724 6.52726 2.66594 12.0025 2.66594ZM12.1301 12.1499L12.1309 6.00094H10.8009V12.496L10.8095 12.6026C10.8379 12.7774 10.9353 12.9354 11.0824 13.0392L15.5195 16.1722L16.2866 15.0857L12.1301 12.1499Z"
        fill="#001E50"
      />
    </svg>
  );
}
